<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_contact_new' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
      <app-icon>person_add</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">
        {{ 'board_v3_contact_new' | translate }}
      </h2>
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="cancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <form class="crm-scroll flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4" (ngSubmit)="submit()">
    @if (duplicate) {
      <div class="flex flex-col gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-3 text-sm text-amber-800">
        <div class="flex items-start gap-2">
          <app-icon class="!h-5 !w-5 shrink-0 !text-[20px] !leading-5">warning</app-icon>
          <span>{{ 'board_v3_contact_duplicate' | translate: { name: getContactName(duplicate) } }}</span>
        </div>
        @if (cardIds.length) {
          <app-button
            btnType="stroked"
            [customClass]="'!h-8 !rounded-md !px-3 !text-sm'"
            [disabled]="saving"
            (onChangeClick)="linkDuplicate()"
          >
            {{ 'board_v3_contact_link_existing' | translate }}
          </app-button>
        }
      </div>
    }

    <app-input
      [formControl]="form.controls.first_name"
      [label]="'first_name' | translate"
      [required]="true"
      [maxlength]="255"
    />
    <app-input [formControl]="form.controls.last_name" [label]="'last_name' | translate" [maxlength]="255" />
    <app-input [formControl]="form.controls.middle_name" [label]="'middle_name' | translate" [maxlength]="255" />

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium text-gray-700">{{ 'phones' | translate }}</span>
      @for (control of phones.controls; track control) {
        <div class="flex min-w-0 items-start gap-2">
          <app-input class="block min-w-0 flex-1" [formControl]="control" placeholder="+380..." />
          <button
            type="button"
            class="mt-1 grid h-8 w-8 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100 hover:text-red-500"
            [attr.aria-label]="'delete' | translate"
            (click)="removePhone($index)"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">close</app-icon>
          </button>
        </div>
      }
      <button
        type="button"
        class="flex items-center gap-1 self-start text-xs font-semibold text-blue-500 hover:text-blue-600"
        (click)="addPhone()"
      >
        <app-icon class="!h-[14px] !w-[14px] !text-[14px] !leading-none">add</app-icon>
        {{ 'add_phone' | translate }}
      </button>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium text-gray-700">{{ 'emails' | translate }}</span>
      @for (control of emails.controls; track control) {
        <div class="flex min-w-0 items-start gap-2">
          <app-input class="block min-w-0 flex-1" [formControl]="control" placeholder="email@example.com" />
          <button
            type="button"
            class="mt-1 grid h-8 w-8 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100 hover:text-red-500"
            [attr.aria-label]="'delete' | translate"
            (click)="removeEmail($index)"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">close</app-icon>
          </button>
        </div>
      }
      <button
        type="button"
        class="flex items-center gap-1 self-start text-xs font-semibold text-blue-500 hover:text-blue-600"
        (click)="addEmail()"
      >
        <app-icon class="!h-[14px] !w-[14px] !text-[14px] !leading-none">add</app-icon>
        {{ 'add_email' | translate }}
      </button>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium text-gray-700">{{ 'addresses' | translate }}</span>
      <app-board-v3-address-editor [formControl]="form.controls.addresses" />
    </div>
  </form>

  <footer class="flex shrink-0 gap-2 border-t border-gray-100 px-4 py-3">
    <app-button btnType="stroked" class="flex-1" [customClass]="'w-full !h-10 !rounded-lg'" (onChangeClick)="cancel()">
      {{ 'cancel' | translate }}
    </app-button>
    <app-button
      class="flex-1"
      [customClass]="'w-full !h-10 !rounded-lg'"
      [disabled]="saving"
      (onChangeClick)="submit()"
    >
      {{ (saving ? 'saving' : 'create') | translate }}
    </app-button>
  </footer>
</section>
